import React from 'react';
import classNames from 'classnames';
import { ConnectedAddSegment } from './AddSegment';
import { CMS } from '../../../../utils/CMS/index';
import { ABUtils } from '../../../../utils';

export const AddSegmentTextMobile = () => {
    const { isCssVariationMobile } = ABUtils.getABs();
    const className = classNames({
        'odf-btn odf-btn-secondary odf-btn-circle odf-btn-circle-md': !isCssVariationMobile,
        'prisma-btn prisma-btn-default prisma-btn-icon-only prisma-btn-circle prisma-btn-sm': isCssVariationMobile,
    });
    const classNameIcon = classNames({
        'odf-icon odf-icon-plus': true,
        'odf-icon-xl': isCssVariationMobile,
    });

    return (
        <ConnectedAddSegment render={
            (onClick, buttonLabel) => (
                <div className="odf-flex-container-row odf-flex-container-gutter-sm" onClick={onClick}>
                    <div className="odf-flex-item odf-flex-item-sm">
                        <button
                            className={className}
                            type="button"
                        >
                            <span className={classNameIcon} />
                        </button>
                    </div>
                    <div className="odf-flex-item">
                        <span className="odf-text-action odf-text-lg">
                            <CMS id={buttonLabel} />
                        </span>
                    </div>
                </div>
            )
        }
        />
    );
};
